const STATE = {
  isLoading: {
    main: false,
    barChart: false,
    drawer: false,
  },
  qualityTablesData: null,
  barChartData: null,
  periodBarChart: null,
  origins: null,
  tags: null,
  filteredTableData: null,
  filteredBarChartData: null,
  selectedOrigin: '',
  selectedTag: '',
  searchValue: '',
  selectedPeriod: '',
  validityDrawer: {
    isOpen: false,
    data: null,
  },
  initialPeriodBarChartData: null,
  currentPage: 1,
  // State for views filter
  views: null,
  currentView: '',
};

export default STATE;